import BasePropertyView from 'BasePropertyView.js';
import eventBus         from 'EventBus.js';
import contentTemplate from 'properties/style/grid.ejs';
import TextUtil from 'util/TextUtil.js';
import undoService from 'UndoService';
import constants from 'Constants.js';

class StyleGridView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]': 'updateAttributes',
            'keydown input[name=gridWidth],input[name=gridHeight]': 'tab'
        };

        return this;
    }

    tab(ev){
        const propName = ev.currentTarget.name.trim();
        let propVal  = ev.currentTarget.value.trim();
        let oldVal=this.model.get(propName);

        if (ev.keyCode === 13 || ev.keyCode === 9) {
            if(oldVal!==propVal){
                $('input[name="'+propName+'"]').trigger('change');
            }else{
                TextUtil.focusNextElement(ev);
            }
        }
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumeric(ev);
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        let oldValue = this.model.get(propName);

        let validateValue = (newValue) => {
            if ( isNaN(newValue) || newValue < 0 || newValue > 100 ) {
                this.render();
            } else {
                this.model.set(propName, newValue);
                if (propName === 'gridWidth') {
                    eventBus.trigger('gridWidthSet', newValue);
                }

                if (propName === 'gridHeight') {
                    eventBus.trigger('gridHeightSet', newValue);
                }
            }
        };
        
        if (oldValue.toString() !== propVal.toString()) { 
            validateValue(parseInt(propVal));
            undoService.add({
                undo: () =>{
                    validateValue(oldValue);                    

                    this.render();
                },
                redo:() => {
                    validateValue(propVal);   

                    this.render();
                }
            }, constants.UNDO_PROP_CHANGE);
        }      

        TextUtil.focusNextElement(ev);

    }

    render() {
        this.$el.empty();
        var that = this;

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default StyleGridView;
